/* eslint-disable no-unused-vars */
import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { MapPin, PlayCircle } from 'phosphor-react';
import LazyLoad from 'react-lazyload';
import Button from '../../../common/button/Button';

const ClientsCardComponent = ({ title, filteredClientsData }) => {
    const history = useHistory();

    return (
        <div className="tw-container">
            <h2>
                {title}
            </h2>
            <div className="segments">
                {filteredClientsData.map((client) => (
                    client.segment === title &&
                    <div key={`clients-${client.slug}`} className="clientBlock">
                        <LazyLoad
                            height={220}
                            offset={100}
                            once
                            className="lazyLoad"
                        >
                            <img src={`https://a1media.antena1.com.br/image/clientes/400x200/${client.imageFile !== null ? client.imageFile : 'defaultCliente.png'}`} alt={`Logo de ${client.name}`} />
                        </LazyLoad>
                        <div className="extraInfos">
                            <div className="extraInfosTexts">
                                <h6 className="clientName">
                                    {client.name}
                                </h6>
                                <p className="clientDescription">
                                    {client.shortDescription.substring(0, 80)}
                                    {client.shortDescription.trim().length > 80 ? '...' : ''}
                                </p>
                            </div>
                            <div className="container-buttons">
                                <div className="tw-flex">
                                    <Button
                                        className="extraInfosItem"
                                        title="Mostrar Praças"
                                        onClick={() => history.push(`/clientes/${client.slug}`)}
                                    >
                                        <MapPin size={20} />
                                        <span>
                                            {`(${client.locations.length})`}
                                        </span>
                                    </Button>
                                    <Button
                                        className="extraInfosItem"
                                        title="Mostrar Spots"
                                        onClick={() => history.push(`/clientes/${client.slug}#Spots`)}
                                    >
                                        <PlayCircle size={20} />
                                        <span>
                                            {`(${client.numSpots})`}
                                        </span>

                                    </Button>
                                </div>

                                <Button className="moreButton" title={`Saiba mais sobre ${client.name}`} to={`/clientes/${client.slug}`}>Saiba mais</Button>

                            </div>
                        </div>
                        <div className="locationsContainer">
                            {
                                client.locations.length > 0 ?
                                    // eslint-disable-next-line react/jsx-one-expression-per-line
                                    client.locations.map((location) => <div key={location} className="locationsItem">{location}</div>)
                                    : <div key="noLocation" className="locationsItem">Sem praça</div>
                            }
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

ClientsCardComponent.propTypes = exact({
    title: PropTypes.string.isRequired,
    filteredClientsData: PropTypes.array.isRequired,

});

export default ClientsCardComponent;
